"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skeleton = void 0;
var _react = _interopRequireDefault(require("react"));
var _Item = require("./Item");
require("./Skeleton.scss");
require("../Cart/Cart.scss");
require("../Cart/Header/Header.scss");
require("../Cart/Header/Title/Title.scss");
require("../Cart/Item/Item/Item.scss");
require("../Cart/Item/Item/Actions/Actions.scss");
require("../Cart/Item/Item/Details/Details.scss");
require("../Cart/Item/Item/HiddenPrice/HiddenPrice.scss");
require("../Cart/Item/Item/ImageLink/ImageLink.scss");
require("../Cart/Item/Item/Price/Price.scss");
require("../Cart/Item/Item/PriceDiscount/PriceDiscount.scss");
require("../Cart/Item/Item/PriceTotal/PriceTotal.scss");
require("../Cart/Item/Item/Quantity/Quantity.scss");
require("../Cart/Item/Item/Reference/Reference.scss");
require("../Cart/Item/Item/Remove/Remove.scss");
require("../Cart/Item/Item/StockCount/StockCount.scss");
require("../Cart/Item/Item/Title/Title.scss");
var Skeleton = function Skeleton(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "cds-Cart cds-Listing cds-Skeleton-Wrapper--Pulse"
  }, /*#__PURE__*/_react["default"].createElement("li", {
    className: "cds-Cart-Header cds-Listing-Header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Cart-HeaderTitle cds-Listing-HeaderTitle cds-Cart-HeaderTitle--Thumb"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Cart-HeaderTitle cds-Listing-HeaderTitle cds-Cart-HeaderTitle--Title  cds-Skeleton--TextShort"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Cart-HeaderTitle cds-Listing-HeaderTitle cds-Cart-HeaderTitle--StockNumber cds-Skeleton--TextShort"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Cart-HeaderTitle cds-Listing-HeaderTitle cds-Cart-HeaderTitle--Price cds-Skeleton--TextShort"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Cart-HeaderTitle cds-Listing-HeaderTitle cds-Cart-HeaderTitle--Quantity cds-Skeleton--TextShort"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Cart-HeaderTitle cds-Listing-HeaderTitle cds-Cart-HeaderTitle--Total cds-Skeleton--TextShort"
  })), children);
};
exports.Skeleton = Skeleton;
Skeleton.Item = _Item.Item;